var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStargate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7565_2390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7565_2390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7565_2390",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7565_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.961 1.98904L31.2916 5.10571C33.9033 11.2252 38.7775 16.0994 44.8969 18.7111L48.0136 20.0417C48.8293 20.3895 49.4914 20.8883 50.0026 21.4825C48.4505 10.3538 39.6489 1.55091 28.5203 0C29.1133 0.509918 29.6132 1.17333 29.961 1.98904Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98904 20.0417L5.10571 18.7111C11.2251 16.0994 16.0993 11.2252 18.7122 5.10571L20.0416 1.98904C20.3906 1.17333 20.8895 0.509918 21.4823 0C10.3537 1.55091 1.5521 10.3538 0 21.4825C0.51116 20.8883 1.17337 20.3895 1.98904 20.0417Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0136 29.9564L44.8969 31.287C38.7775 33.8985 33.9033 38.774 31.2916 44.8935L29.961 48.0089C29.6132 48.8246 29.1133 49.4881 28.5203 49.9993C39.6489 48.4472 48.4505 39.6443 50.0026 28.5156C49.4914 29.1097 48.8293 29.6084 48.0136 29.9564Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0416 48.0089L18.7122 44.8935C16.0993 38.774 11.2251 33.8985 5.10571 31.287L1.98904 29.9564C1.17337 29.6084 0.51116 29.1097 0 28.5156C1.5521 39.6443 10.3537 48.4472 21.4823 49.9993C20.8895 49.4881 20.3906 48.8246 20.0416 48.0089Z",
    fill: "#999999"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6588 22.5582L15.1948 21.9022C18.21 20.6148 20.6125 18.2136 21.8998 15.1984L22.5546 13.6623C23.473 11.5111 26.5227 11.5111 27.4411 13.6623L28.0959 15.1984C29.3831 18.2136 31.7857 20.6148 34.8008 21.9022L36.3369 22.5582C38.4881 23.4765 38.4881 26.5251 36.3369 27.4436L34.8008 28.0996C31.7857 29.3868 29.3831 31.788 28.0959 34.8045L27.4411 36.3392C26.5227 38.4904 23.473 38.4904 22.5546 36.3392L21.8998 34.8045C20.6125 31.788 18.21 29.3868 15.1948 28.0996L13.6588 27.4436C11.5076 26.5251 11.5076 23.4765 13.6588 22.5582Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargate);
export default __webpack_public_path__ + "static/media/Stargate.bb65c9f6ab12ab72e80d88856e86e66d.svg";
export { ForwardRef as ReactComponent };